export default __webpack_public_path__ + "static/media/avatar-s-11.9d32c98c.jpg";